import { gql } from '@apollo/client';

export const GET_BRAND_RESTRICTED_CATEGORIES = gql`
  query GetBrandRestrictedCategories {
    getBrandRestrictedCategories {
      id
      name
      usedByBrandsCount
      usedByTalentsCount
    }
  }
`;
